var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { ExpansionHeaderContainer, ExpansionDataPoint } from './styles';
import { ExpansionContext } from './expansion-context';
export default function ExpansionHeader(_a) {
    var children = _a.children, details = _a.details;
    var _b = useContext(ExpansionContext), dataColumnWidth = _b.dataColumnWidth, mainColumnWidth = _b.mainColumnWidth;
    return (_jsxs(ExpansionHeaderContainer, __assign({ container: true }, { children: [_jsx(Grid, __assign({ item: true, sm: mainColumnWidth, xs: mainColumnWidth }, { children: _jsx(Typography, __assign({ variant: "labelMedium", noWrap: true }, { children: children })) })), details && details.map(function (detail) { return (_jsx(ExpansionDataPoint, __assign({ item: true, sm: dataColumnWidth, xs: dataColumnWidth, zeroMinWidth: true }, { children: _jsx(Typography, __assign({ variant: "overline", noWrap: true }, { children: detail })) }), "ExpansionHeader-".concat(detail === null || detail === void 0 ? void 0 : detail.toString()))); })] })));
}
